<template>
  <div class="campaign-left-sidebar" ref="campaignLeftSidebarRef">
    <div class="px-3 pb-3" ref="newNotificationButtonRef">
      <NewNotificationButton />
    </div>
    <div class="campaign-left-sidebar--campaign-picker px-3 pb-3" ref="campaignPickerRef">
      <div class="w-100">
        <b-dropdown
          ref="campaignPickerDropdown"
          class="campaign-picker-dropdown border"
          split
          :variant="isDarkMode ? 'dark' : 'light'"
        >
          <template #button-content>
            <span
              class="d-inline-flex w-100 h-100 justify-content-center align-items-center"
              style="padding: .375rem .75rem;"
              @click="showCampaignPickerDropdown"
            >
              {{ currentCampaign ? currentCampaign.campaign_name : campaignPickerLabel }}
            </span>
          </template>
          <b-dropdown-item
            v-for="option in currentCampaigns"
            :key="option.campaign_id"
            @click="selectCampaign(option)"
          >
            {{ option.campaign_name }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div
      class="campaign-left-sidebar--campaign-events d-flex align-items-center justify-content-center"
      :style="{ height: `${eventListHeight}px` }"
    >
      <b-spinner v-if="isLoadingCampaignEvents"></b-spinner>
      <CampaignEventList
        v-if="!isLoadingCampaignEvents && campaignEvents.length > 0"
        :eventList="campaignEvents"
        :currentEventId="currentCampaignEventId"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import CampaignEventList from "./CampaignEventList.vue";
import NewNotificationButton from "@/components/action_buttons/NewNotificationButton";
export default {
  name: "CampaignLeftSidebar",
  components: {
    CampaignEventList,
    NewNotificationButton,
  },
  data() {
    return {
      isLoadingCampaings: false,
      isLoadingCampaignEvents: false,
      campaignEvents: [],
      eventListHeight: 300
    };
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser", "isDarkMode"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("campaigns", ["currentCampaigns", "currentCampaignEvents", "currentCampaign"]),
    campaignPickerLabel() {
      return this.currentCampaigns.length === 0 ? "You have no campaigns" : "Select campaign";
    },
    currentCampaignEventId() {
      return this.$route.params.campaignEventId;
    }
  },
  created() {
    this.$nextTick(() => {
      if (
        this.$refs.campaignLeftSidebarRef &&
        this.$refs.campaignLeftSidebarRef.clientHeight &&
        this.$refs.campaignPickerRef &&
        this.$refs.campaignPickerRef.clientHeight &&
        this.$refs.newNotificationButtonRef &&
        this.$refs.newNotificationButtonRef.clientHeight
      ) {
        this.eventListHeight = this.$refs.campaignLeftSidebarRef.clientHeight
        this.eventListHeight -= this.$refs.campaignPickerRef.clientHeight;
        this.eventListHeight -= this.$refs.newNotificationButtonRef.clientHeight;
      }
    });
    if (this.$route.params.campaignId) {
      const currentCampaign = this.currentCampaigns.find(item => item.campaign_id === this.$route.params.campaignId);
      if (currentCampaign) {
        this.selectCampaign(currentCampaign, false);
      }
    }
  },
  methods: {
    showCampaignPickerDropdown() {
      this.$refs.campaignPickerDropdown.show();
    },
    async selectCampaign(campaign, navigateToCampaign = true) {
      const { campaign_id } = campaign;
      this.$store.commit("campaigns/setCurrentCampaign", campaign);
      await this.getCampaignEvents(campaign_id);
      if (navigateToCampaign) {
        this.$router.push({path: `/campaigns/${campaign_id}`}).catch(() => {});
      }
    },
    async getCampaignEvents(campaignId) {
      try {
        this.isLoadingCampaignEvents = true;
        const resp = await this.$ConveyApi.campaignsApi.getCampaignEvents({
          campaignId,
          params: { status: 'active' }
        });
        if (resp.data.data && resp.data.data.length > 0) {
          this.$store.commit("campaigns/setCurrentCampaignEvents", [...resp.data.data]);
        } else {
          this.$store.commit("campaigns/setCurrentCampaignEvents", []);
        }
      } catch (err) {
        console.log("[CampaignLeftSidebar:getCampaignEvents] ERROR: ", err);
        this.$store.commit("campaigns/setCurrentCampaignEvents", []);
      } finally {
        this.isLoadingCampaignEvents = false;
      }
    },
  },
  watch: {
    currentCampaignEvents: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.campaignEvents = [...newVal];
        } else {
          this.campaignEvents = [];
        }
      },
      deep: true,
      immediate: true,
    }
  },
};
</script>

<style lang="scss">
.campaign-left-sidebar {
  width: 100%;
  height: 100%;

  &--campaign-picker {
    width: 100%;
    .campaign-picker-dropdown {
      width: 100%;
      min-width: 120px;
      border-radius: 1.5rem;
      border-color: #455a64 !important;
      &.btn-group {
        >button {
          text-align: left;
          &:first-child {
            padding: 0;
          }
        }
        .dropdown-toggle-split {
          flex: unset;
        }
      }
    }
  }
  &--campaign-events {
    width: 100%;
  }
}
</style>
